import React from "react";
import { Button } from "components/ui/button";
import { CalendarDays, Plus } from "lucide-react";

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  showAction?: boolean;
  variant?: "default" | "campaign";
  actionIcon?: React.ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  actionLabel,
  onAction,
  showAction = false,
  variant = "default",
  actionIcon = <Plus aria-hidden="true" className="mr-2 h-4 w-4" />,
}) => {
  const getDefaultIcon = () => {
    if (variant === "campaign") {
      return <CalendarDays aria-hidden="true" className="h-7 w-7" />;
    }

    return (
      <svg aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
        <path
          fillRule="evenodd"
          d="M4 3a2 2 0 00-2 2v1.586l8 8 8-8V5a2 2 0 00-2-2H4zm5.707 8.707L18 3.414V16a2 2 0 01-2 2H4a2 2 0 01-2-2V3.414l8.293 8.293a1 1 0 001.414 0z"
          clipRule="evenodd"
        />
      </svg>
    );
  };

  return (
    <div
      className="flex min-h-72 flex-col items-center justify-center rounded-lg border border-dashed border-gray-200 bg-gray-50/60 px-6 py-12 text-center"
      role="status"
    >
      <div className="mx-auto max-w-md">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-white text-[#705260] shadow-sm">
          {icon || getDefaultIcon()}
        </div>
        <h3 className="mb-2 text-lg font-semibold text-gray-900">{title}</h3>
        <p className="mb-6 text-sm leading-6 text-gray-600">{description}</p>
        {showAction && actionLabel && onAction && (
          <Button className="min-h-11" onClick={onAction}>
            {actionIcon}
            {actionLabel}
          </Button>
        )}
      </div>
    </div>
  );
};
